import { inject, observer } from 'mobx-react';
import * as React from 'react';
export var SuccessInfo = inject('checkAddressStore', 'config')(observer(function (props) {
    var checkAddressStore = props.checkAddressStore, config = props.config;
    var _a = React.useState(''), address = _a[0], setAddress = _a[1];
    var _b = React.useState(false), canUpgrade = _b[0], setCanUpgrade = _b[1];
    React.useEffect(function () {
        var providerCode = checkAddressStore.providerCode;
        var upgradeStatus = providerCode === 'Uniti'
            ? false
            : checkAddressStore.sqAddressResponse.sqSummary.nbn
                .alternativeTechnologyDetails != null
                ? checkAddressStore.sqAddressResponse.sqSummary.nbn
                    .alternativeTechnologyDetails.readyStatus
                : false;
        if (config.wholesaleCustomerCode !== 'OT' && upgradeStatus) {
            setCanUpgrade(true);
        }
        setAddress(checkAddressStore.formattedAddress);
    }, []);
    var qualifyUpgrade = function (e) {
        if (e && e.preventDefault)
            e.preventDefault();
        checkAddressStore.upgardeSelected = true;
        checkAddressStore.flipToFibreService = true;
        checkAddressStore.serviceClass = 1;
        checkAddressStore.isLineInUse = false;
        console.log('isLineInUse', checkAddressStore.isLineInUse);
    };
    return (React.createElement("div", { className: "service-query-result" },
        React.createElement("h4", { className: "great-news" },
            "Great news! The",
            ' ',
            checkAddressStore.providerCode === 'Uniti'
                ? 'Fibre service'
                : 'nbn™',
            ' ',
            "is available at your place."),
        canUpgrade && (React.createElement(React.Fragment, null,
            React.createElement("h4", { className: "great-news" }, "You can also upgrade with Flip to Fibre\u2122 with a FREE Fibre-to-the-home connection upgrade with an eligble plan."),
            React.createElement("button", { type: "button", className: "btn btn-primary", onClick: qualifyUpgrade, disabled: checkAddressStore.upgardeSelected }, "Yes! I'll Upgrade"),
            React.createElement("p", null,
                React.createElement("small", null, "Click on the button if you want to upgrade, otherwise continue on your sign up.")))),
        React.createElement("p", { className: "nbn-service-details" },
            "These plans are available at your address:",
            React.createElement("br", null),
            React.createElement("i", { style: { opacity: 0.8, fontStyle: 'normal', fontWeight: 'bold' } }, address),
            React.createElement("br", null),
            canUpgrade && !checkAddressStore.upgardeSelected
                ? "Alternate Technology: Fibre"
                : '')));
}));
//# sourceMappingURL=SuccessInfo.js.map